import Slider from "react-slick";
import { FaStar } from "react-icons/fa";

const reviews = [
  {
    text: "Physica's home physiotherapy sessions were a game-changer for my recovery.",
    name: "Sunita Patel",
    subtitle: "Recovered From Knee Surgery, Mumbai",
    rating: 5,
  },
  {
    text: "The therapist was highly knowledgeable and friendly. My back pain is almost gone now.",
    name: "Rahul Verma",
    subtitle: "Lower Back Pain, Pune",
    rating: 5,
  },
  {
    text: "They were punctual, professional, and made exercises easy for my elderly father.",
    name: "Neeta Shah",
    subtitle: "Post-Operative Rehab, Delhi",
    rating: 5,
  },
  {
    text: "Seamless experience. Their customer support and therapists are excellent.",
    name: "Aman Gupta",
    subtitle: "Sports Injury, Gurgaon",
    rating: 4,
  },
  {
    text: "Affordable and very effective. My knee feels so much better after a week!",
    name: "Priya Menon",
    subtitle: "Knee Pain, Noida",
    rating: 5,
  },
];

const TestimonialCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    dotsClass: "slick-dots custom-dots",
  };

  return (
    <div className="max-w-xl mx-auto mt-10 px-6 pb-20 overflow-visible">
      <Slider {...settings}>
        {reviews.map((review, index) => (
          <div key={index} className="px-1">
            <div className="bg-white shadow-md rounded-3xl p-6 mb-5 text-center text-[#3B2C34]">
              <p className="text-md font-medium mb-4 leading-relaxed">“{review.text}”</p>
              <div className="mt-4 text-left">
                <p className="font-semibold">{review.name}</p>
                <p className="text-sm text-gray-600">{review.subtitle}</p>
                <div className="flex items-center gap-1 mt-2 text-yellow-400 text-sm">
                  <span className="text-black text-xs font-semibold">{review.rating}/5</span>
                  {[...Array(review.rating)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TestimonialCarousel;
